import React, { useState, useEffect } from 'react';
import axios from 'axios';

const API_URL = process.env.REACT_APP_API_URL || `${API_CONFIG.API_URL}`;

const CadastrarFornecedorModal = ({ onClose, onFornecedorCriado, fornecedorEdit }) => {
  const [formData, setFormData] = useState({
    nome: '',
    tipo: 'Pessoa Física',
    cpf_cnpj: '',
    telefone: '',
    email: '',
    endereco: {
      rua: '',
      numero: '',
      complemento: '',
      bairro: '',
      cidade: '',
      estado: '',
      cep: ''
    },
    observacoes: '',
    ativo: true
  });

  const [carregando, setCarregando] = useState(false);
  const [erro, setErro] = useState('');

  useEffect(() => {
    if (fornecedorEdit) {
      setFormData({
        ...fornecedorEdit,
        endereco: fornecedorEdit.endereco || {
          rua: '',
          numero: '',
          complemento: '',
          bairro: '',
          cidade: '',
          estado: '',
          cep: ''
        }
      });
    }
  }, [fornecedorEdit]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    
    if (name.startsWith('endereco.')) {
      const enderecoField = name.split('.')[1];
      setFormData(prev => ({
        ...prev,
        endereco: {
          ...prev.endereco,
          [enderecoField]: value
        }
      }));
    } else {
      setFormData(prev => ({
        ...prev,
        [name]: type === 'checkbox' ? checked : value
      }));
    }
  };

  const formatarCPFCNPJ = (valor) => {
    const numeros = valor.replace(/\D/g, '');
    
    if (numeros.length <= 11) {
      // CPF: 000.000.000-00
      return numeros.replace(/(\d{3})(\d{3})(\d{3})(\d{2})/, '$1.$2.$3-$4');
    } else {
      // CNPJ: 00.000.000/0000-00
      return numeros.replace(/(\d{2})(\d{3})(\d{3})(\d{4})(\d{2})/, '$1.$2.$3/$4-$5');
    }
  };

  const handleCPFCNPJChange = (e) => {
    const valor = e.target.value;
    const formatado = formatarCPFCNPJ(valor);
    setFormData(prev => ({ ...prev, cpf_cnpj: formatado }));
  };

  const validarFormulario = () => {
    if (!formData.nome.trim()) {
      setErro('Nome é obrigatório');
      return false;
    }
    return true;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    if (!validarFormulario()) {
      return;
    }

    setCarregando(true);
    setErro('');

    try {
      const token = localStorage.getItem('token');
      const url = fornecedorEdit 
        ? `${API_URL}/fornecedores/${fornecedorEdit._id}`
        : `${API_URL}/fornecedores`;
      
      const method = fornecedorEdit ? 'put' : 'post';

      const response = await axios[method](url, formData, {
        headers: { 'x-auth-token': token }
      });

      if (response.data.success) {
        if (onFornecedorCriado) {
          onFornecedorCriado();
        }
        onClose();
      }
    } catch (error) {
      setErro(error.response?.data?.erro || 'Erro ao salvar fornecedor');
    } finally {
      setCarregando(false);
    }
  };

  return (
    <div className="modal-overlay-preencher">
      <div className="modal-content" style={{ maxWidth: '800px', maxHeight: '90vh', overflowY: 'auto' }}>
        <div className="modal-preencher-header">
          <h2>{fornecedorEdit ? 'Editar Fornecedor' : 'Cadastrar Fornecedor'}</h2>
          <button className="close-button" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit} className="editar-usuario-form">
          <div className="modal-body">
            {erro && (
              <div style={{ 
                padding: '12px', 
                background: '#fee', 
                color: '#c00', 
                borderRadius: '4px',
                marginBottom: '1rem'
              }}>
                {erro}
              </div>
            )}

            <div className="form-section">
              <h3 className="section-title">Dados Principais</h3>
              
              <div className="form-row">
                <div className="form-group" style={{ flex: 2 }}>
                  <label>Nome / Razão Social *</label>
                  <input
                    type="text"
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required
                  />
                </div>
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Tipo *</label>
                  <select
                    name="tipo"
                    value={formData.tipo}
                    onChange={handleChange}
                    required
                  >
                    <option value="Pessoa Física">Pessoa Física</option>
                    <option value="Pessoa Jurídica">Pessoa Jurídica</option>
                  </select>
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>{formData.tipo === 'Pessoa Física' ? 'CPF' : 'CNPJ'}</label>
                  <input
                    type="text"
                    name="cpf_cnpj"
                    value={formData.cpf_cnpj}
                    onChange={handleCPFCNPJChange}
                    maxLength={formData.tipo === 'Pessoa Física' ? 14 : 18}
                  />
                </div>
                <div className="form-group">
                  <label>Telefone</label>
                  <input
                    type="text"
                    name="telefone"
                    value={formData.telefone}
                    onChange={handleChange}
                    placeholder="(00) 00000-0000"
                  />
                </div>
                <div className="form-group">
                  <label>E-mail</label>
                  <input
                    type="email"
                    name="email"
                    value={formData.email}
                    onChange={handleChange}
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3 className="section-title">Endereço</h3>
              
              <div className="form-row">
                <div className="form-group" style={{ flex: 3 }}>
                  <label>Rua</label>
                  <input
                    type="text"
                    name="endereco.rua"
                    value={formData.endereco.rua}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Número</label>
                  <input
                    type="text"
                    name="endereco.numero"
                    value={formData.endereco.numero}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label>Complemento</label>
                  <input
                    type="text"
                    name="endereco.complemento"
                    value={formData.endereco.complemento}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group">
                  <label>Bairro</label>
                  <input
                    type="text"
                    name="endereco.bairro"
                    value={formData.endereco.bairro}
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="form-row">
                <div className="form-group" style={{ flex: 2 }}>
                  <label>Cidade</label>
                  <input
                    type="text"
                    name="endereco.cidade"
                    value={formData.endereco.cidade}
                    onChange={handleChange}
                  />
                </div>
                <div className="form-group" style={{ flex: 1 }}>
                  <label>Estado</label>
                  <input
                    type="text"
                    name="endereco.estado"
                    value={formData.endereco.estado}
                    onChange={handleChange}
                    maxLength={2}
                    placeholder="SP"
                  />
                </div>
                <div className="form-group" style={{ flex: 1 }}>
                  <label>CEP</label>
                  <input
                    type="text"
                    name="endereco.cep"
                    value={formData.endereco.cep}
                    onChange={handleChange}
                    placeholder="00000-000"
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h3 className="section-title">Observações</h3>
              <div className="form-group">
                <textarea
                  name="observacoes"
                  value={formData.observacoes}
                  onChange={handleChange}
                  rows={3}
                  placeholder="Informações adicionais sobre o fornecedor..."
                  style={{ width: '100%', resize: 'vertical' }}
                />
              </div>
            </div>

            <div className="form-section">
              <div className="form-group">
                <label style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <input
                    type="checkbox"
                    name="ativo"
                    checked={formData.ativo}
                    onChange={handleChange}
                  />
                  Fornecedor ativo
                </label>
              </div>
            </div>
          </div>

          <div className="modal-footer">
            <button 
              type="button" 
              className="btn-cancel" 
              onClick={onClose}
              disabled={carregando}
            >
              Cancelar
            </button>
            <button 
              type="submit" 
              className="btn-save"
              disabled={carregando}
            >
              {carregando ? 'Salvando...' : (fornecedorEdit ? 'Atualizar' : 'Cadastrar')}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default CadastrarFornecedorModal;
